// extracted by mini-css-extract-plugin
module.exports = {"modal":"_5D1jVWti","is-open":"_5D3UlE5n","card":"_5DL4ERhC","close":"_5D2841ax","container":"_5D1bOB9L","main":"_5D2-jTF7"};